var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
    stroke: "#D7263D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9609 14.2109H11.0547L10.6562 6.57812H13.3594L12.9609 14.2109ZM10.625 16.8828C10.625 16.4453 10.7422 16.1146 10.9766 15.8906C11.2109 15.6667 11.5521 15.5547 12 15.5547C12.4323 15.5547 12.7656 15.6693 13 15.8984C13.2396 16.1276 13.3594 16.4557 13.3594 16.8828C13.3594 17.2943 13.2396 17.6198 13 17.8594C12.7604 18.0938 12.4271 18.2109 12 18.2109C11.5625 18.2109 11.224 18.0964 10.9844 17.8672C10.7448 17.6328 10.625 17.3047 10.625 16.8828Z",
    fill: "#D7263D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4770f6aa2edbc2baad78e836797f836c.svg";
export { ForwardRef as ReactComponent };